
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruiter/onboarding",
      function () {
        return require("private-next-pages/recruiter/onboarding/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruiter/onboarding"])
      });
    }
  